module.exports = __webpack_public_path__ + "img/admin_title.76502956.png";